import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactInfo, PhoneModel } from '../../models';
import { environment } from '../../../environments/environment';
import { ContactService, NotificationService, SEOService } from '../../services';
import { orgaPartners } from '../../../assets/ressources/orga-partners';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { Utils } from '../../shared/utils';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { TextFormFieldComponent } from '../../shared/components/inputs/text-form-field/text-form-field.component';
import { PhoneFormFieldComponent } from '../../shared/components/inputs/phone-form-field/phone-form-field.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AllOrganizersCarouselComponent } from '../../shared/components/all-organizers-carousel/all-organizers-carousel.component';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    MatCard,
    MatCardContent,
    MatTabGroup,
    MatTab,
    FormsModule,
    ReactiveFormsModule,
    TextFormFieldComponent,
    PhoneFormFieldComponent,
    MatButton,
    MatIcon,
    AllOrganizersCarouselComponent,
  ],
})
export class DemoComponent implements OnInit {
  private contactService = inject(ContactService);
  private seoService = inject(SEOService);
  private notificationService = inject(NotificationService);
  private translocoService = inject(TranslocoService);

  private environmentName = environment.envName !== 'prod' ? `[${environment.envName}] ` : '';
  public sendingRequest = false;
  @ViewChild('demoFormDir') demoFormDir: FormGroupDirective;
  @ViewChild('callFormDir') callFormDir: FormGroupDirective;
  public demoForm = new UntypedFormGroup({});
  public callForm = new UntypedFormGroup({});
  public nameRegex = Utils.nameRegex;
  public demoModel = {
    fullName: '',
    email: '',
    organization: '',
    phone: new PhoneModel(),
  };
  orgaPartners: Array<{imgUrl: string, name: string, website: string}> = orgaPartners;

  ngOnInit() {
    this.seoService.updateTitle('Demande de démo - Reelax Tickets');
    this.seoService.updateDescription('Prenons rendez-vous pour une démonstration. Avec Reelax Tickets, protégez vos spectateurs en leur proposant le 1er service français de revente légale !');
  }

  sendDemoRequest() {
    const contactPayload: ContactInfo = {
      fullName: `${this.demoForm.value.fullName} (${this.demoForm.value.organization})`,
      mailAddress: this.demoForm.value.email,
      subject: `${this.environmentName}Organisateur - Demande de démo`,
      message: `${this.demoForm.value.fullName} de ${this.demoForm.value.organization} souhaite recevoir une démo du service ! \n
      Vous pouvez le contacter au : ${this.demoForm.value.email} | (${this.demoForm.value.phone?.extension ?? ''}) ${this.demoForm.value.phone?.digits ?? ''} \n
      `,
    };
    this.sendRequest(contactPayload);
  }

  sendCallRequest() {
    const contactPayload: ContactInfo = {
      fullName: `Nouvel Organisateur : ${this.callForm.value.organization}`,
      mailAddress: 'noreply@reelax-tickets.com',
      subject: `${this.environmentName}Organisateur - Demande de rappel téléphonique pour démo`,
      message: `${this.callForm.value.organization} sur Reelax Tickets souhaite recevoir une démo du service ! \n
      Veuillez le rappeler dès que possible au : (${this.callForm.value.phone?.extension ?? ''}) ${this.callForm.value.phone?.digits ?? ''} \n
      `,
    };
    this.sendRequest(contactPayload);
  }

  sendRequest(contactPayload: ContactInfo) {
    this.sendingRequest = true;
    this.contactService.sendMessage(contactPayload).subscribe({
      next: () => {
        this.sendingRequest = false;
        this.demoFormDir.resetForm();
        this.callFormDir.resetForm();
        this.notificationService.open(this.translocoService.translate('demo.requestWellSent'));
      },
      error: (err) => {
        // eslint-disable-next-line no-console
        console.log('Error on sending demo request email : ', err);
        this.sendingRequest = false;
      },
    });
  }

}
